(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('route', {
                parent: 'entity',
                url: '/route',
                data: {
                    authorities: [],
                    pageTitle: 'Routes'
                },
                ncyBreadcrumb: {
                    label: 'Routes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/route/list/route.html',
                        controller: 'RouteController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_ROUTE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_ROUTE, access);
                }]
            });
    }

})();
